import YesNoDialog, { YesNoDialogProps } from "components/dialogs/YesNoDialog";
import useShowDialog from "hooks/useShowDialog";
import { createContext, ReactNode } from "react";

export interface DialogProviderProps {
  showDialog: (props: YesNoDialogProps) => void;
  hideDialog: () => void;
}

export const DialogContext = createContext<DialogProviderProps>({
  showDialog: (props) => {},
  hideDialog: () => {},
});

export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const { showDialog, hideDialog, dialogState } = useShowDialog();

  return (
    <DialogContext.Provider value={{ showDialog, hideDialog }}>
      {children}
      <YesNoDialog
        title={dialogState.title}
        open={dialogState.open}
        onNoButtonClicked={hideDialog}
        yesButtonStartIcon={dialogState.yesButtonStartIcon}
        type={dialogState.type}
        yesButtonText={dialogState.yesButtonText}
        onYesButtonClicked={dialogState.onYesButtonClicked}
        noButtonText={dialogState.noButtonText}
        contentText={dialogState.contentText}
      />
    </DialogContext.Provider>
  );
};
